// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3HFKk","left":"InfoRow_left__lMTOA"};